import React from 'react';
import { iconFromString } from "../../helpers/images";
import { generateModifierClasses } from "../../modules/utils";
const Icon = function ({ alt, modifiers, name }) { return /*#__PURE__*/ React.createElement("img", { className: generateModifierClasses('icon', modifiers), alt: alt ?? '', src: name ? iconFromString(name) : undefined }); };
export default Icon;
